import { Spinner } from "@components/ui-kit";
import { NotFoundOutgoingInvoice } from "@components/widgets/ErrorPage";
import {
  type OutgoingInvoice,
  OutgoingInvoiceTypeEnum,
  useOutgoingInvoiceQuery,
} from "@src/__generated__/graphql";
import { useStore } from "@src/utils/hooks";
import { FormMode } from "@src/utils/types";
import { observer } from "mobx-react-lite";
import { useState } from "react";
import { Container } from "../components";
import { InvoiceStore, InvoiceStoreContext, InvoiceTypeEnum } from "../store";

interface EditOutgoingProps {
  id: string;
}

export const EditOutgoing = observer(function EditOutgoing({
  id,
}: EditOutgoingProps) {
  const appStore = useStore();
  const [store] = useState(
    () =>
      new InvoiceStore(
        appStore,
        false,
        InvoiceTypeEnum.Outgoing,
        FormMode.EDIT,
      ),
  );

  const { data, loading } = useOutgoingInvoiceQuery({
    variables: { id },
    skip: !id,
    onCompleted({ outgoingInvoice }) {
      if (outgoingInvoice) {
        store.setDataFromOI(outgoingInvoice);
      }
    },
  });

  if (loading) {
    return <Spinner absolute />;
  }

  if (!data?.outgoingInvoice) {
    return <NotFoundOutgoingInvoice />;
  }

  if (
    !store.invoice ||
    (store.invoice as OutgoingInvoice).type ===
      OutgoingInvoiceTypeEnum.ProformaPayment
  ) {
    return null;
  }

  return (
    <InvoiceStoreContext.Provider value={store}>
      <Container />
    </InvoiceStoreContext.Provider>
  );
});
